
export const COLORS = {
  BALL: '#ffffff',
  SHOOT: '#ffea00',
  SUB: '#00ff88',
  YELLOW: '#ffee00',
  RED: '#ff0044',
  OFFSIDE: '#ff8800',
  TACKLE: '#00d0ff',
  PITCH: '#0a2214'
};

export const GAME_DURATION = 30; // seconds
export const ORB_BASE_LIFESPAN = 1800; // ms
